"use client";
import { CarouselButton } from "@/components/common";
import { useCarouselButtons } from "@repo/lib/hooks/common";
import { CartContext, useCartContext } from "@repo/contexts/CartContext";
import { ProductCard } from "@repo/ui";
import cx from "classnames";
import useEmblaCarousel from "embla-carousel-react";
import { useLocale } from "next-intl";
import { useCallback } from "react";

const ProductSlider = (props) => {
  const {
    title,
    items,
    wishlistItems,
    className = "",
    isMedium,
    session,
    isMiniCartSlider,
  } = props;
  const locale = useLocale();
  const isEnglish = locale === "en";
  const OPTIONS = {
    align: "start",
    slidesToScroll: 1,
    direction: isEnglish ? "ltr" : "rtl",
  };
  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS);
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = useCarouselButtons(emblaApi);

  const isCarouselButtonEnabled =
    items?.length > 4 || (isMiniCartSlider && items?.length > 1);
  const { setShowMiniCart } = useCartContext(CartContext);

  // Close minicart on click of wishlist item in minicart
  const handleCloseMiniCart = useCallback(
    () => setShowMiniCart(false),
    [setShowMiniCart]
  );

  return (
    <div
      className={cx({
        "py-4": isMedium || isMiniCartSlider,
      })}
    >
      <div
        className={cx("flex items-center", {
          "py-6": isMedium,
          "py-2.5": !isMedium,
        })}
      >
        <span
          className={cx(
            "font-heading text-supportiveBlack rtl:font-arabic font-medium",
            {
              "text-xl md:text-4xl": isMedium,
              "text-sm md:text-base": !isMedium,
            }
          )}
        >
          {title}
        </span>
        {isCarouselButtonEnabled && (
          <div className="ms-auto hidden md:block">
            <div className="flex">
              <CarouselButton
                direction={isEnglish ? "prev" : "next"}
                onClick={onPrevButtonClick}
                disabled={prevBtnDisabled}
                variant="product"
                className={isEnglish ? "border-r" : "border-l"}
              />
              <CarouselButton
                direction={isEnglish ? "next" : "prev"}
                onClick={onNextButtonClick}
                disabled={nextBtnDisabled}
                variant="product"
                className={isEnglish ? "border-l-0" : "border-r-0"}
              />
            </div>
          </div>
        )}
      </div>
      <div className={`m-auto max-w-full ${className}`}>
        <div className="overflow-hidden" ref={emblaRef}>
          <div className="ml-[calc(1rem*-1)] flex touch-pan-y touch-pinch-zoom">
            {items?.map((item) => (
              <div
                className={cx("flex-[0_0_45%] pl-4", {
                  "md:flex-[0_0_25%]": isMedium,
                  "md:flex-[0_0_33.33%]": !isMedium,
                  "md:flex-[0_0_75%]": !isMedium && isMiniCartSlider,
                })}
                key={item?.id}
              >
                <div className="flex">
                  <ProductCard
                    product={item}
                    wishlistItems={wishlistItems}
                    session={session}
                    handleCloseMiniCart={handleCloseMiniCart}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSlider;
